const semanticClassNames = {
  root: 'time-picker',
  input: 'time-picker__input',
  icon: 'time-picker__icon',
  label: 'time-picker__label',
} as const;

export default semanticClassNames;
